import React from "react";
import {
  Parah,
  PointsIcon,
  PointsWrapper,
  SubTitle,
  ThirdTitle,
} from "../ContentsStyles";

const CG_4 = () => {
  return (
    <>
      <Parah>
        We strive to create a platform that feels welcoming and safe. We do not
        allow nudity, pornography, or sexually explicit content on our platform.
        We also prohibit content depicting or supporting non-consensual sexual
        acts, the sharing of non-consensual intimate imagery, and adult sexual
        solicitation.
      </Parah>
      <SubTitle>Sexual Exploitation</SubTitle>
      <Parah>
        Sexual exploitation is defined as any actual or attempted abuse of a
        position of vulnerability, power, or trust for sexual purposes,
        including profiting monetarily, socially, or politically from the sexual
        exploitation of another. We do not permit sexually exploitative content.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that depicts, solicits, promotes, normalizes, or glorifies
        non-consensual sexual acts or non-consensual touching, including rape
        and sexual assault.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that depicts, solicits, promotes, normalizes, or glorifies the
        sharing of non-consensual intimate imagery, including sexual images that
        are taken, created, or shared without consent.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that depicts, promotes, normalizes, or glorifies sexual
        violence.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that depicts, promotes, or glorifies sexual solicitation,
        including offering or asking for sexual partners, sexual chats or
        imagery, sexual services, premium sexual content, or sex scamming.
      </PointsWrapper>
      <SubTitle>Nudity and Sexual Activity Involving Adults</SubTitle>
      <Parah>
        Nudity and sexual activity include content that is overtly revealing of
        breasts, genitals, anus, or buttocks, or behaviours that mimic, imply,
        or display sex acts. We do not allow depictions, including digitally
        created or manipulated content, of nudity or sexual activity. We are
        mindful that some content may be offensive or culturally inappropriate
        in certain regions or may not be suitable for users of all ages.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that explicitly or implicitly depicts sexual activities
        including penetrative and non-penetrative sex, oral sex, or erotic
        kissing.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that depicts sexual arousal or sexual stimulation
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that depicts a sexual fetish
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that depicts genitals, buttocks, the pubic region, or female
        nipples
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that contains sexually explicit language for sexual
        gratification
      </PointsWrapper>
    </>
  );
};

export default CG_4;
